import _ from 'underscore';
import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormService, FORM_STATES } from '@bingads-webui-react/form-core';
import { useWizardService } from '@bingads-webui-react/wizard-core';
import { SINGLE_STEP_EVENT, USER_TRIGGER_STEP_EVENT, USER_TRIGGER_STEP_EVENT_KEYS } from './constants';

const matchStepSubState = (wizardState, stepSubState) => {
  const stateArr = wizardState.toStrings();
  const fullState = stateArr[stateArr.length - 1];
  return fullState.includes(stepSubState);
};

/**
 * This component logs the single step, which needs to be put under the FormService.
 * @param {writeLog} write log function, e.g., API call or aria logging
 * @returns {void}
 */
export const SingleStepLogger = ({ writeLog }) => {
  const [startTime, setStartTime] = useState(Date.now());
  const { state } = useFormService();
  const isLoading = state.matches(FORM_STATES.LOADING);
  const isSaveSucceeded = state.matches(FORM_STATES.SAVING_SUCCEEDED);
  const isSaveFailed = state.matches(FORM_STATES.SAVING_FAILED);

  const { state: wizardState } = useWizardService();
  const [trigger, setTrigger] = useState(null);

  useEffect(() => {
    if (_.some(USER_TRIGGER_STEP_EVENT_KEYS, key => matchStepSubState(wizardState, key))) {
      const triggerKey = _.find(USER_TRIGGER_STEP_EVENT_KEYS, key => matchStepSubState(wizardState, key));
      setTrigger(USER_TRIGGER_STEP_EVENT[triggerKey]);
    }
  }, [wizardState]);

  const triggerWriteLog = useCallback((EventName, EventValue) => {
    writeLog({
      EventName,
      EventValue,
    });
  }, [writeLog]);

  useEffect(() => {
    if (isLoading) {
      setStartTime(Date.now());
      triggerWriteLog(SINGLE_STEP_EVENT.LOADING);
    }
  }, [isLoading, triggerWriteLog]);

  useEffect(() => {
    if (isSaveSucceeded) {
      const duration = Date.now() - startTime;
      triggerWriteLog(SINGLE_STEP_EVENT.SAVING_SUCCEEDED, {
        duration,
        trigger,
      });
    }
  }, [trigger, isSaveSucceeded, startTime, triggerWriteLog]);

  useEffect(() => {
    if (isSaveFailed) {
      triggerWriteLog(SINGLE_STEP_EVENT.SAVING_FAILED, {
        trigger,
      });
    }
  }, [trigger, isSaveFailed, triggerWriteLog, writeLog]);

  return null;
};

SingleStepLogger.propTypes = {
  writeLog: PropTypes.func.isRequired,
};
